import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _templateObject, _templateObject2;
var _excluded = ["backgroundColor", "hasIcon"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import TipIcon from '@atlaskit/icon/glyph/editor/hint';
import { PanelType } from '@atlaskit/adf-schema';
import { panelSharedStylesWithoutPrefix, PanelSharedCssClassName } from '@atlaskit/editor-common/panel';
import { hexToEditorBackgroundPaletteColor } from '@atlaskit/editor-palette';
import EmojiIcon from '@atlaskit/icon/glyph/editor/emoji';
import EmojiItem from './emoji';
import { PanelInfoIcon, PanelSuccessIcon, PanelNoteIcon, PanelWarningIcon, PanelErrorIcon } from '@atlaskit/editor-common/icons';
var PanelStyled = function PanelStyled(_ref) {
  var backgroundColor = _ref.backgroundColor,
    hasIcon = _ref.hasIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- nested css mixins are violations
  var styles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t&.", " {\n\t\t\t", "\n\n\t\t\t&[data-panel-type=", "] {\n\t\t\t\t", "\n\t\t\t}\n\t\t}\n\t"])), PanelSharedCssClassName.prefix, panelSharedStylesWithoutPrefix(), PanelType.CUSTOM, hasIcon ? '' : 'padding-left: 12px;padding-right: 12px;');
  if (props['data-panel-type'] === PanelType.CUSTOM && backgroundColor) {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- nested css mixins are violations
    styles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t&.", " {\n\t\t\t\t", "\n\t\t\t}\n\n\t\t\t&[data-panel-type=", "] {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\t", "\n\t\t\t}\n\t\t"])), PanelSharedCssClassName.prefix, panelSharedStylesWithoutPrefix(), PanelType.CUSTOM, hexToEditorBackgroundPaletteColor(backgroundColor) || backgroundColor, hasIcon ? '' : 'padding-left: 12px;padding-right: 12px;');
  }
  return (
    // eslint-disable-next-line
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", _extends({
      css: styles
    }, props), props.children)
  );
};
PanelStyled.displayName = 'PanelStyled';
var panelIcons = {
  info: PanelInfoIcon,
  success: PanelSuccessIcon,
  note: PanelNoteIcon,
  tip: TipIcon,
  warning: PanelWarningIcon,
  error: PanelErrorIcon,
  custom: EmojiIcon
};
var Panel = function Panel(props) {
  var allowCustomPanels = props.allowCustomPanels,
    type = props.panelType,
    panelColor = props.panelColor,
    panelIcon = props.panelIcon,
    panelIconId = props.panelIconId,
    panelIconText = props.panelIconText,
    providers = props.providers,
    children = props.children;
  // only allow custom panel type if flag is set
  // otherwise fall back to info if custom panel is given
  var panelType = allowCustomPanels ? type : type === PanelType.CUSTOM ? PanelType.INFO : type;
  var getIcon = function getIcon() {
    if (panelType === PanelType.CUSTOM) {
      if (panelIcon && providers) {
        return jsx(EmojiItem, {
          id: panelIconId,
          text: panelIconText,
          shortName: panelIcon,
          providers: providers
        });
      }
      return null;
    }
    var Icon = panelIcons[panelType];
    return jsx(Icon, {
      label: "Panel ".concat(panelType)
    });
  };
  var icon = getIcon();
  var renderIcon = function renderIcon() {
    if (icon) {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      return jsx("div", {
        className: PanelSharedCssClassName.icon
      }, icon);
    }
  };
  return jsx(PanelStyled
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  , {
    className: PanelSharedCssClassName.prefix,
    "data-panel-type": panelType,
    "data-panel-color": panelColor,
    "data-panel-icon": panelIcon,
    "data-panel-icon-id": panelIconId,
    "data-panel-icon-text": panelIconText,
    backgroundColor: panelColor,
    hasIcon: Boolean(icon)
  }, renderIcon(), jsx("div", {
    className: PanelSharedCssClassName.content
  }, children));
};
export default Panel;